var youtubeAccessibilityPromise = new Promise(function (resolve) {
    var image = new Image();
    image.onload = function () {
        resolve(true);
    };
    image.onerror = function () {
        resolve(false);
    };
    image.src = '//youtube.com/favicon.ico';
});
export var isYoutubeAccessible = function () {
    return youtubeAccessibilityPromise;
};
